import React, { useMemo } from 'react';
import PageInnerTabs from 'components/system/PageInnerTabs';
import EmployeeRecordTabs from './EmployeeRecordTabs';
import {
  EmployeeBasicInfo1Tab,
  EmployeeBasicInfo2Tab,
  EmployeeMasterPlaceholderTab,
} from './EmployeeBasicInfoTabs';
import {
  loadHiddenMasterTabsFromLocal,
  resolveMasterDetailTabs,
} from './masterDetailTabConfig';

/**
 * 인사마스터 우측 — 1차 탭 (기본정보1/2 · 급여기초 · 인적사항 · 인사기록카드)
 */
const EmployeeMasterDetailTabs = ({ employeeContext, tenantCode }) => {
  const visibleDefs = useMemo(() => {
    const hiddenTabIds = loadHiddenMasterTabsFromLocal();
    return resolveMasterDetailTabs({ tenantCode, hiddenTabIds });
  }, [tenantCode]);

  const tabsConfig = useMemo(
    () =>
      visibleDefs.map((def) => {
        if (def.id === 'basic1') {
          return {
            id: def.id,
            label: def.label,
            component: (props) => <EmployeeBasicInfo1Tab tenantCode={props.tenantCode || tenantCode} />,
          };
        }
        if (def.id === 'basic2') {
          return { id: def.id, label: def.label, component: EmployeeBasicInfo2Tab };
        }
        if (def.id === 'records') {
          return {
            id: def.id,
            label: def.label,
            component: (props) => (
              <div style={{ flex: 1, minHeight: 0, height: '100%', display: 'flex', flexDirection: 'column', padding: '4px 6px 8px', boxSizing: 'border-box' }}>
                <EmployeeRecordTabs employeeContext={props.employeeContext} />
              </div>
            ),
          };
        }
        return {
          id: def.id,
          label: def.label,
          component: (props) => (
            <EmployeeMasterPlaceholderTab tabLabel={props.tabLabel || def.label} />
          ),
        };
      }),
    [visibleDefs, tenantCode]
  );

  const sharedProps = useMemo(() => ({ employeeContext, tenantCode }), [employeeContext, tenantCode]);
  const defaultActiveTabId = visibleDefs[0]?.id || 'basic1';

  if (!tabsConfig.length) {
    return (
      <div style={{ padding: 16, color: '#6B7280' }}>
        표시 가능한 상세 탭이 없습니다. 기관 탭 설정을 확인해 주세요.
      </div>
    );
  }

  return (
    <div style={{ flex: 1, minHeight: 0, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
      <PageInnerTabs
        tabsConfig={tabsConfig}
        defaultActiveTabId={defaultActiveTabId}
        sharedProps={sharedProps}
        keepMounted
      />
    </div>
  );
};

export default EmployeeMasterDetailTabs;
